export const en = {
  navbar: {
    logo: 'moonbird',
    benefits: 'Benefits',
    features: 'Features',
    testimonials: 'Testimonials',
    tryMoonbird: 'Try moonbird',
  },
  hero: {
    title: 'Breathe better.\nSleep better.',
    description:
      'Discover how the moonbird breathing device can help you fall asleep faster and improve your sleep quality naturally.',
    tryButton: 'Try moonbird for 30 days',
    learnMoreButton: 'Learn more',
    discoverMore: 'Discover more',
  },
  benefits: {
    title: 'Benefits of better breathing',
    description:
      'Moonbird guides you to the optimal breathing rhythm for better sleep and relaxation',
    items: [
      {
        title: 'Fall asleep faster',
        description:
          'Guided breathing helps calm your mind and body, reducing the time it takes to fall asleep by up to 40%.',
      },
      {
        title: 'Wake up refreshed',
        description:
          'Improve your sleep quality and wake up feeling naturally energized and ready for the day.',
      },
      {
        title: 'Reduce stress & anxiety',
        description:
          'Regular breathing exercises help lower cortisol levels and activate your parasympathetic nervous system.',
      },
    ],
  },
  features: {
    title: 'How moonbird works',
    description:
      'A simple device with powerful technology to guide your breathing',
    items: [
      {
        title: 'Tactile guidance',
        description:
          'Moonbird expands and contracts in your hand, guiding your breathing without the need to look at a screen.',
      },
      {
        title: 'Scientifically proven',
        description:
          'Our breathing exercises are based on scientific research and proven to help with sleep, stress, and anxiety.',
      },
      {
        title: 'Long battery life',
        description:
          'Use moonbird for up to 3 weeks on a single charge, making it perfect for travel and daily use.',
      },
      {
        title: 'Optional app',
        description:
          'Connect to our app for personalized exercises, progress tracking, and additional guidance.',
      },
    ],
  },
  testimonials: {
    title: 'What our users say',
    description: 'Thousands of people have improved their sleep with moonbird',
    items: [
      {
        quote:
          "I've struggled with insomnia for years. Moonbird has helped me fall asleep in minutes rather than hours. It's been life-changing.",
        author: 'Sarah M.',
        role: 'Insomniac for 7 years',
      },
      {
        quote:
          'As a therapist, I recommend moonbird to my clients with anxiety. The physical guidance makes it easier to maintain breathing practice.',
        author: 'Dr. James K.',
        role: 'Clinical psychologist',
      },
      {
        quote:
          "I travel frequently for work and often have jet lag. Moonbird helps me reset my sleep cycle no matter which time zone I'm in.",
        author: 'Michael T.',
        role: 'Business traveler',
      },
    ],
  },
  cta: {
    title: 'Start your journey to better sleep',
    description:
      'Join thousands of people who have improved their sleep with moonbird',
    button: 'Try moonbird for 30 days',
    disclaimer: 'Money-back guarantee. No questions asked.',
    benefits: [
      'Fall asleep faster',
      'Reduce stress & anxiety',
      'Improve sleep quality',
      '30-day risk-free trial',
      'Free shipping worldwide',
    ],
  },
  footer: {
    description:
      'A handheld breathing coach for better sleep, less stress, and improved wellbeing.',
    product: {
      title: 'Product',
      links: ['Features', 'How it works', 'Pricing', 'FAQ'],
    },
    resources: {
      title: 'Resources',
      links: ['Sleep science', 'Breathing techniques', 'Blog', 'Research'],
    },
    company: {
      title: 'Company',
      links: ['About us', 'Contact', 'Careers', 'Press'],
    },
    legal: ['Privacy policy', 'Terms of service', 'Shipping'],
    copyright: '© {year} moonbird. All rights reserved.',
  },
}
